<template>
  <div class="footerContainer">
    <div class="content contentWidth flex-space-between">
      <div class="leftFoot flex-start">
        <img src="@/assets/image/qrcode.png" alt="" class="QRCode"/>
        <div class="leftDiv">
          <p class="scanTip">扫一扫关注公众号</p>
          <p><span class="bigFont numberFont">24</span>小时服务热线</p>
          <p class="phone numberFont">0755-26339288</p>
        </div>
      </div>
      <div class="rightFoot flex-start-start">
        <div class="linkDiv">
          <p class="linkType">网站导航</p>
          <div class="linkList">
            <router-link to="login"><p class="link">首页</p></router-link>
            <router-link to="resolve"><p class="link">解决方案</p></router-link>
            <router-link to="introduction"><p class="link">业务介绍</p></router-link>
            <router-link to="connectUs"><p class="link">联系我们</p></router-link>
          </div>
        </div>
        <div class="linkDiv">
          <p class="linkType">友情链接</p>
          <div class="linkList">
            <a href="https://www.yeahka.com/index.html" target="_blank">移卡科技</a>
            <a href="https://jh.leshuazf.com/#/login" target="_blank">乐刷聚合支付</a>
            <a href="https://www.yuque.com/leshuazf/doc/spomzg" target="_blank">聚合支付开发文档</a>
            <router-link to="partner"><p class="link">合作伙伴</p></router-link>
          </div>
        </div>
        <div class="linkDiv">
          <p class="linkType">联系方式</p>
          <div class="linkList">
            <p>电话 : 0755-26339288</p>
            <p>邮箱 : sara@yeahka.com</p>
            <p>地址 : 广东省深圳市南山区科兴科学园A4栋4楼</p>
          </div>
        </div>
      </div>
    </div>
    <p class="btmText contentWidth">Copyright © 2012-2020   Yeahka All Rights Reserved</p>
  </div>
</template>

<script>
export default {
  name: 'footBtm'
}
</script>

<style scoped lang="less">
.footerContainer{
  width: 100%;
  background: #1C1B27;
  margin-top: 82px;
  padding-bottom: 60px;
  .content{
    padding-top: 60px;
    padding-bottom: 39px;
    color: #fff;
    .leftFoot{
      .QRCode{
        width: 140px;
        height: 140px;
        display: inline-block;
        margin-right: 20px;
      }
      .leftDiv{
        font-size: 16px;
        line-height: 16px;
        .scanTip{
          margin-bottom: 24px;
        }
        .bigFont{
          font-size: 30px;
          margin-right: 4px;
        }
        .phone{
          font-size: 24px;
          margin-top: 16px;
        }
      }
    }
    .rightFoot{
      .linkDiv{
        margin-left: 70px;
        &:nth-child(3n+1){
          margin-left: 0;
        }
        .linkType{
          color: #fff;
          font-size: 20px;
          line-height: 19px;
          margin-bottom: 31px;
        }
        .linkList{
          font-size: 14px;
          p,a{
            line-height: 14px;
            margin-bottom: 15px;
            color: #878787;
            display: block;
          }
          a,.link{
            &:hover{
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }
  .btmText{
    color: #878787;
    font-size: 12px;
  }
}
</style>
